
import { format, parseISO } from "date-fns";
import { ItineraryEvent } from "@/types/itinerary";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const groupEventsByDate = (events: ItineraryEvent[]) => {
  const groupedEvents: { [key: string]: ItineraryEvent[] } = {};
  
  events.forEach(event => {
    // Use parseISO to ensure proper date parsing
    const dateObj = parseISO(event.date);
    const dateKey = format(dateObj, 'yyyy-MM-dd');
    
    if (!groupedEvents[dateKey]) {
      groupedEvents[dateKey] = [];
    }
    groupedEvents[dateKey].push(event);
  });
  
  // Sort each day's events by order_index
  Object.keys(groupedEvents).forEach(date => {
    groupedEvents[date].sort((a, b) => a.order_index - b.order_index);
  });
  
  return groupedEvents;
};

export const handleDeleteEvent = async (eventId: string, userId: string | null) => {
  if (!userId) return false;
  
  try {
    const { error } = await supabase
      .from('itinerary_events')
      .delete()
      .eq('id', eventId);
      
    if (error) throw error;
    toast.success("Event deleted successfully");
    return true;
  } catch (error) {
    console.error("Error deleting event:", error);
    toast.error("Failed to delete event");
    return false;
  }
};

export const reorderEvents = async (events: ItineraryEvent[], sourceIndex: number, destinationIndex: number, dateKey: string) => {
  const dateEvents = events.filter(event => {
    const eventDate = parseISO(event.date);
    return format(eventDate, 'yyyy-MM-dd') === dateKey;
  });
  
  const reorderedEvents = Array.from(dateEvents);
  const [movedEvent] = reorderedEvents.splice(sourceIndex, 1);
  reorderedEvents.splice(destinationIndex, 0, movedEvent);
  
  // Update local state format
  const newEvents = [...events];
  reorderedEvents.forEach((event, index) => {
    const eventIndex = newEvents.findIndex(e => e.id === event.id);
    if (eventIndex >= 0) {
      newEvents[eventIndex] = { ...event, order_index: index };
    }
  });
  
  try {
    for (let i = 0; i < reorderedEvents.length; i++) {
      await supabase
        .from('itinerary_events')
        .update({ order_index: i })
        .eq('id', reorderedEvents[i].id);
    }
    return newEvents;
  } catch (error) {
    console.error("Error updating event order:", error);
    toast.error("Failed to save event order");
    return null;
  }
};
